<template>
    <v-container>
        <v-card elevation="0">
            <v-card-title>
                <v-spacer></v-spacer>
                <v-btn text color="primary">nueva actividad</v-btn>
            </v-card-title>
            <v-card-text>
                <v-data-table>
                </v-data-table>
            </v-card-text>
        </v-card>

    </v-container>
</template>

<script>
export default {

}
</script>